export const tempScale: {
  min: number;
  max: number;
  step: number;
  marks: number[];
} = {
  min: -10,
  max: 30,
  step: 5,
  marks: Array.from({ length: 10 }, (v, k) => k * 5 - 10),
};
